import { cloneDeep } from 'lodash-es';
import { v4 as uuid } from 'uuid';

import {
  FilterKindEnum,
  GenericOccurredOperation,
  RadioTextFilterOperation,
  SubFilterErrorKind,
} from '@hotjar/global-filters';
import type { GlobalFilter, DEVICE_TYPE, DeviceFilter, ErrorFilter } from '@hotjar/global-filters';

import { TARGETING_VALUE } from '../constants-types/HeatmapTargetingOptions';
import type { HeatmapParams } from '../constants-types/HeatmapParams';

export function mapDeviceToGlobalFilter(device: HeatmapDeviceTypes): DeviceFilter {
  return {
    id: uuid(),
    kind: FilterKindEnum.DeviceType,
    value: [device as DEVICE_TYPE],
  };
}

export function mapTargetingValueToRadioTextFilterOperation(
  targetingValue: TargetingValue,
): RadioTextFilterOperation {
  switch (targetingValue) {
    case TARGETING_VALUE.EXACT:
      return RadioTextFilterOperation.IS_EXACTLY;
    case TARGETING_VALUE.SIMPLE:
      return RadioTextFilterOperation.IS;
    case TARGETING_VALUE.CONTAINS:
      return RadioTextFilterOperation.CONTAINS;
    case TARGETING_VALUE.STARTS_WITH:
      return RadioTextFilterOperation.STARTS_WITH;
    case TARGETING_VALUE.ENDS_WITH:
      return RadioTextFilterOperation.ENDS_WITH;
    case TARGETING_VALUE.REGEX:
      return RadioTextFilterOperation.REGEX;
    default:
      return RadioTextFilterOperation.IS;
  }
}

export function mapHeatmapParamsToGlobalFilters(
  params: HeatmapParams,
  skipDevice?: boolean,
): GlobalFilter {
  const filtersInUiFormat = cloneDeep(params.filters);

  if (!(skipDevice ?? false)) {
    filtersInUiFormat.filterList.push(mapDeviceToGlobalFilter(params.device));
  }

  const urlFilterOperation = mapTargetingValueToRadioTextFilterOperation(params.match);

  filtersInUiFormat.filterList.push({
    id: uuid(),
    kind: FilterKindEnum.VisitedURL,
    value: {
      operation: urlFilterOperation,
      value: params.url,
    },
  });

  return filtersInUiFormat;
}

export function mapErrorOnPageToGlobalFilter(
  selectedTargetingValue: TargetingValue,
  searchPattern: string,
): ErrorFilter {
  return {
    id: uuid(),
    kind: FilterKindEnum.Error,
    value: {
      operation: GenericOccurredOperation.OCCURRED,
      subFilters: [
        {
          id: uuid(),
          kind: SubFilterErrorKind.PAGE_PATH,
          value: {
            operation: mapTargetingValueToRadioTextFilterOperation(selectedTargetingValue),
            value: searchPattern,
          },
        },
      ],
    },
  };
}
